import React, { useEffect, useState } from 'react'
import moment from "moment";
import { AlertNotif } from "../../../../../Library/AlertNotif";
import LoadingBtn from "../../../../Widgets/LoadingBtn";
import { openModal } from '../../../../../Library/ModalPopUp';
import { ComparingDateJoin } from './_core';
import { GET_SECTION } from './APIs';

const ButtonPrevNext = ({ handlerPrevNextMonth, selected_date }) => {
    return (
        <div className="btn-group">
            <button
                className="btn btn-light btn-sm btn-icon"
                onClick={() => handlerPrevNextMonth(1)}
            >
                <i className="icon-1x flaticon2-left-arrow"></i>
            </button>
            <button className="btn btn-light btn-sm font-weight-boldest">
                <span className="text-dark">{selected_date
                    ? moment(selected_date).format("MMMM YYYY")
                    : moment().format("MMMM YYYY")}
                </span>
            </button>
            <button
                className="btn btn-light btn-sm btn-icon"
                onClick={() => handlerPrevNextMonth(2)}
            >
                <i className="icon-1x flaticon2-right-arrow"></i>
            </button>
        </div>
    );
};

const RenderDayCell = (dayRenderInfo) => {
    const { date, isOther, dayNumberText } = dayRenderInfo;
    if (isOther) {
        return (
            <div className="fc-daygrid-day-top">
                <a className="fc-daygrid-day-number">
                    {dayNumberText} {moment(date).format("MMM")}
                </a>
            </div>
        );
    }
    return (
        <div className="fc-daygrid-day-top">
            <a className="fc-daygrid-day-number">{dayNumberText}</a>
        </div>
    );
};

const RenderEventsStd = (data) => {
    let item = data.event;
    const groupData = JSON.parse(item.groupId);
    const start_dt = groupData.start_dt
        ? moment(groupData.start_dt).format("hh:mm a")
        : item.start;
    const end_dt = groupData.end_dt
        ? moment(groupData.end_dt).format("hh:mm a")
        : item.end;
    const event_name = item?.title || "-";

    return (
        <div
            className="px-2 cursor-pointer"
            onClick={() => openModal({ header: "Schedule Selected", message: <DetailEvents data={groupData} /> })}
        >
            <div className='fc-day-grid-event fc-start fc-end fc-event-solid-danger fc-event-light'>
                <div className="fc-content text-primary">
                    <span className="fc-time">{start_dt} · {end_dt}</span>
                </div>
                <div className="text-wrap text-primary">
                    <span>{event_name}</span>
                </div>

                {groupData.event_room && (
                    <div style={{ color: groupData.colorDef }}>
                        <span className="text-wrap me-1 fs-8 text-primary">Rooms:</span>
                        {groupData.event_room.map((v, index) => (
                            <span className="fs-8 text-primary" key={index}>
                                {v.room
                                    ? v.room.g_resourceName
                                    : "-"}
                                {Object.values(groupData.event_room).length - 1 > index
                                    ? ", "
                                    : ""}
                            </span>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

const DetailEvents = ({ data }) => {
    const event_name = data.label ? data.label : data?.course?.coursetitle || "-";
    const date_start = ComparingDateJoin(data?.start_dt, data?.end_dt);
    const [results, setResults] = useState({
        loading: false,
        data: [],
        message: "",
    });
    const ReloadData = async () => {
        setResults({ loading: true, data: [], message: "" });
        const result = await GET_SECTION({ section_id: data.section_id });
        if (result.data && Object.values(result.data).length > 0) {
            const get_one = result.data[0];
            setResults({ loading: false, data: get_one, message: "" });
        } else {
            setResults(result);
        }
    };

    useEffect(() => {
        if (data.section_id) {
            ReloadData();
        }
    }, [data.section_id]);

    return (
        <div className="detail-event">
            <table className="table table-head-custom table-head-bg table-borderless table-vertical-start">
                <thead>
                    <tr className='text-left text-uppercase'>
                        <th colSpan={2}>Detail Schedule</th>
                    </tr>
                </thead>
                <tbody>
                    {data.section_id && (
                        <>
                            <tr>
                                <td className='font-weight-bold'>Section ID</td>
                                <td>{data.section_id}</td>
                            </tr>
                        </>
                    )}

                    <tr>
                        <td className='font-weight-bold'>{data.section_id ? 'Course' : 'Event'}</td>
                        <td>{event_name}</td>
                    </tr>

                    {data.event_room && Object.values(data.event_room).length > 0 && (
                        <tr>
                            <td className='font-weight-bold'>Rooms</td>
                            <td>{data.event_room.map((v, index) => (
                                <span key={index}>
                                    {v.room
                                        ? v.room.g_resourceName + "(" + v.room.g_capacity + ")"
                                        : "-"}
                                    {Object.values(data.event_room).length - 1 > index ? ", " : ""}
                                </span>
                            ))}</td>
                        </tr>
                    )}
                    <tr>
                        <td className='font-weight-bold'>Date and Time</td>
                        <td>{date_start}</td>
                    </tr>
                    {results.loading ? (
                        <tr><td colSpan={2}><LoadingBtn /></td></tr>
                    ) : results.message ? (
                        <tr><td colSpan={2}><AlertNotif messages={results.message} /></td></tr>
                    ) : (
                        Object.values(results.data).length > 0 && (
                            <tr>
                                <td className='font-weight-bold'>Class Room</td>
                                <td>
                                    {results.data.g_alternateLink && (
                                        <a href={results.data?.g_alternateLink || "#"}>
                                            Click here to visit Google Class Room
                                        </a>
                                    )}
                                </td>
                            </tr>
                        )
                    )}
                </tbody>
            </table>
            {results.data.g_calendarId && (
                <div className="bg-light-primary rounded p-5">
                    <p className="mb-0 fs-4 font-weight-bold">Notes:</p>
                    <div>
                        To display this course schedule in your Google Calendar,
                        please subscribe by copying this Calendar ID{" "}
                        <span className="text-primary">
                            ({results.data.g_calendarId})
                        </span>
                        , and then follow the instructions provided{" "}
                        <a
                            href="https://support.google.com/calendar/answer/37100?hl=en&co=GENIE.Platform%3DDesktop"
                            target="_blank"
                            className="text-primary"
                        >
                            here
                        </a>
                        .
                    </div>
                </div>
            )}
        </div>
    );
};

export { ButtonPrevNext, RenderDayCell, RenderEventsStd }